const nzTimeZones = ['NZ'].map((value) => {
  const data = value.split('-');
  return {
    label: data[0],
    value: data[data.length - 1],
  };
});

export default nzTimeZones;
